var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classObject},[(_vm.checked)?_c('div',{staticClass:"active-mark"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }